export const CLEAR_RATINGS = 'ratings/CLEAR'
export const UPDATE_RATINGS = 'ratings/UPDATE'
export const FETCH_RATINGS = 'ratings/FETCH'
export const FETCH_RATINGS_SUCCESS = 'ratings/FETCH_SUCCESS'
export const FETCH_RATINGS_FAILURE = 'ratings/FETCH_FAILURE'
export const FETCH_RATINGS_NO_PRICING_SUCCESS = 'ratings/FETCH_RATINGS_NO_PRICING_SUCCESS'
export const FETCH_RATINGS_NO_PRICING_FAILURE = 'ratings/FETCH_RATINGS_NO_PRICING_FAILURE'
export const FETCH_RATINGS_NO_PRICING = 'ratings/FETCH_RATINGS_NO_PRICING'

export const clear = () => ({
  type: CLEAR_RATINGS
})

export const update = ratings => {
    return {
        type: UPDATE_RATINGS,
        value: ratings
    };
};

export const fetch = params => {
    return {
        type: FETCH_RATINGS,
        value: {
            params
        }
    };
};

export const fetchSuccess = data => {
    return {
        type: FETCH_RATINGS_SUCCESS,
        value: data
    };
};

export const fetchFailure = error => {
    return {
        type: FETCH_RATINGS_FAILURE,
        value: error
    };
};


export const fetchRatingsNoPricing = params => {
    return {
        type: FETCH_RATINGS_NO_PRICING,
        value: {
            params
        }
    };
};

export const fetchRatingsNoPricingSuccess = data => {
    return {
        type: FETCH_RATINGS_NO_PRICING_SUCCESS,
        value: data
    };
};

export const fetchRatingsNoPricingFailure = error => {
    return {
        type: FETCH_RATINGS_NO_PRICING_FAILURE,
        value: error
    };
};